module.exports = __webpack_public_path__ + "img/right_arrow.a6ff086a.svg";